import type { VoidFunctionComponent } from 'react';

import { FormLabel, FormLabelVariant, icons } from '../../../../../../generic';
import TooltipIcon from '../../../../../../generic/TooltipIcon';

import styles from './Option.module.less';

export const SavedOptionsLabel: VoidFunctionComponent = () => (
  <FormLabel
    variant={FormLabelVariant.Filter}
    label={
      <span className={styles.savedOptionsLabel}>
        Saved Options
        <span className={styles.savedOptionsTooltipIcon}>
          <TooltipIcon
            id="saved-options-tooltip"
            icon={icons.circleQuestion}
            tooltip="Store your current options configuration for quick reuse in other reports."
            placement="left"
        />
        </span>
      </span>
    }
  />
);
